if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}
            onSubmitHandler(evt) {
				evt.preventDefault();
              let upsellItems = [];

// Get all checked upsell checkboxes
const upsellCheckboxes = document.querySelectorAll('.freq_bout_inputs:checked');

// Iterate over each checked checkbox
upsellCheckboxes.forEach(checkbox => {
    // Get the data-variant attribute value
    const variantSelectorId = checkbox.getAttribute('data-variant');
    
    // Find the corresponding variant dropdown element
    const variantDropdown = document.getElementById(variantSelectorId);
    
    // If the dropdown exists, get the selected variant ID
    if (variantDropdown) {
        const selectedVariantId = variantDropdown.value;
        
        // Push the selected variant ID and quantity to the upsellItems array
        upsellItems.push({
            id: parseInt(selectedVariantId, 10), // Convert to integer if necessary
            quantity: 1 // Assuming 1 as the default quantity, change if needed
        });
    }
});
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);

				// HAUT: Support Custom Stitching Fee Add-On product
				const stitchingInput = this.form.querySelector('input[name="properties[Stitching]"]');
				if (stitchingInput && stitchingInput.value === 'Custom / Bespoke') {
					const stitchingVariantId = this.getAttribute('data-stitching-variant-id');
					if (stitchingVariantId) {
						const mainVariantId = formData.get('id');
						const mainQty = formData.get('quantity') || 1;

						formData.delete('id');
						formData.delete('quantity');

						formData.append('items[0][id]', mainVariantId);
						formData.append('items[0][quantity]', mainQty);

						// Move all properties to items[0][properties]
						const rawFormData = new FormData(this.form);
						for (let pair of rawFormData.entries()) {
							if (pair[0].startsWith('properties[')) {
								const propKey = pair[0].substring(11, pair[0].length - 1);
								formData.append(`items[0][properties][${propKey}]`, pair[1]);
								formData.delete(pair[0]); // Remove from top level
							}
						}

						// Add stitching fee as items[1]
						formData.append('items[1][id]', stitchingVariantId);
						formData.append('items[1][quantity]', 1);
					}
				}

              upsellItems.forEach((upsellItem, index) => {
    // Append upsell item ID and quantity to formData
    formData.append(`items[${index}][id]`, upsellItem.id);
    formData.append(`items[${index}][quantity]`, upsellItem.quantity);
});
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}


			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
